module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAP1BMVEUAAAAAAAAcAAAeEQMdEgIdFAIdFAIeEwMhFwhSST0eEwMtIhNZUUVaUUaDfXSDfXWHgXje3Nr5+fj5+fn///8PVF6yAAAACnRSTlMAAQlMcXJzo+7+gx+I9AAAAF1JREFUCNddj0kSwCAIBHGJSjRxm/+/NWhO0reuYmAgEqwLwVn6MT49tZbkzbbIHULnuNzzwGawl1zqmC3nNtGTJfcA7RYaUByFCuSlGajh0PfSw2qVOqRrqJLHCx8pKgez25f4QgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order/ico_selected.png
// module id = U0dh
// module chunks = 0